import EvaluacionDisciplinaOperativaAdapter from '../adapters/EvaluacionDisciplinaOperativa.adapter'

export default class GetEvaluacionDisciplinaOperativaUseCase {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute({ idPersonal, idEvaluacion }) {
    try {
      const dto = await this.#repository.getById(idPersonal, idEvaluacion)
      return EvaluacionDisciplinaOperativaAdapter.toDomain(dto)
    } catch (error) {
      throw new Error(`Failed to execute GetEvaluacionDisciplinaOperativaUseCase: ${error.message}`)
    }
  }
}
